exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.currency-hover-menu {\n    top: 114px !important;\n    border-radius: 0px !important;\n}\n", ""]);
